module.exports = __webpack_public_path__ + "img/boneca07.f65c82ec.png";